// import { axiosClient } from "../../../../utils/auth.util";
// import React, { useState, useEffect, useCallback } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "./TutorExam.css";
// import { Button, Autocomplete, TextField } from "@mui/material";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import Loader1 from "../../Components/LinearLoder";
// import { decode as atob, encode as btoa } from "base-64";
// import PauseAlertDialog from "./PauseAlertDialog";
// // Removed direct axios import; using axiosClient from auth.util.js

// //
// //

// const TutorExamEntrance = (props) => {
//   var num = 1;
//   const history = useNavigate();
//   const [base64, setBase64] = useState([]);
//   const [answer, setAnswer] = useState({});
//   const [answerObject, setAnswerObject] = useState([]);
//   const [inputId, setInputId] = useState();
//   const [keyArray, setKeyArray] = useState();
//   const [subList, setSubList] = useState([]);
//   const [testSubject, setTestSubject] = useState();
//   const [loaderVisible, setLoaderVisible] = useState(false);
//   const [showPauseAlertDialog, setShowPauseAlertDialog] = useState(false);

//   console.log(subList, "👌👌");

//   const handleClickOpen = (e) => {
//     e.preventDefault();
//     if (subList?.length === 0) {
//       alert("Please select a subject!");
//       return;
//     }
//     setShowPauseAlertDialog(true);
//   };

//   // const changeHandler = (e) => {
//   //   let val = e.target.value;

//   //   setTestSubject(val);
//   //   setSubList([val]);
//   //   props.SelectedSub(val);
//   //   // get_questions()
//   // };

//   const changeHandler = (e, value) => {
//     //let val = e.target.value;
//     if (Array.isArray(value)) {
//       let val = value[0];
//       setTestSubject(val);
//       setSubList([val]);
//       props.SelectedSub([val]);
//     } else {
//       setTestSubject();
//       setSubList([]);
//       props.SelectedSub([]);
//     }
//     // get_questions()
//   };

//   useEffect(() => {
//     let tutor1 = JSON.parse(localStorage.getItem("tutor"));
//     let tutor_ls = JSON.parse(localStorage.getItem("tutor")).saveTutor;

//     let temp_tutorSaveObj = {
//       ...tutor_ls,
//       tutStatus: "ex",
//     };
//     let temp_tutorObj = {
//       ...tutor1,
//       saveTutor: temp_tutorSaveObj,
//     };

//     let tutor_stringified = JSON.stringify(temp_tutorObj);
//     localStorage.setItem("tutor", tutor_stringified);
//   }, []);

//   const get_questions = async () => {
//     console.log({ subjectList: props.subjectList });
//     const getQues = await axiosClient.post(
//       "/tutorweb/get_questions",
//       {
//         subjectList: subList,
//         tutorId: JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id,
//       }
//     );

//     if (getQues?.data?.questionArr?.length !== 0) {
//       console.log({ getQues: getQues.data.questionArr });
//       props.setTimeOfTest(getQues.data.timeOfTest);
//       let keys = getQues.data.keyArr;
//       //   setKeyArray(getQues.data.keyArr)
//       console.log({ keys });

//       let getQuesAr = getQues.data.questionArr;
//       let base64String = [];
//       getQuesAr.map((el) => {
//         base64String.push(
//           // btoa(String.fromCharCode(...new Uint8Array(el.data)))
//           // String.fromCharCode.apply(null, new Uint8Array(el.data))
//           // btoa(unescape(encodeURIComponent(new TextDecoder('utf-8').decode(new Uint8Array(el.data)))))
//           btoa(
//             new Uint8Array(el.data).reduce(function (data, byte) {
//               return data + String.fromCharCode(byte);
//             }, "")
//           )
//         );
//         // const base64String = new Buffer.from(getQues.data.questionArr.data).toString("ascii")
//       });
//       console.log({ base64String });

//       //   setBase64(base64String)
//       props.CurrentBase64_func(base64String);
//       props.key_func(keys);

//       if (base64String.length !== 0) {
//         setLoaderVisible(false);
//         history("/register-dashboard/tutor_exam/sheet",{replace:true});
//       } else {
//         setLoaderVisible(false);
//         alert("Some Error occured.Please try again!");
//       }
//     } else {
//       setLoaderVisible(false);
//       alert("Some Error occured.Please try again!");
//       console.log({ getQues: "not Found" });
//     }
//   };

//   const nextHandler = (e) => {
//     setShowPauseAlertDialog(false);
//     let tutor1 = JSON.parse(localStorage.getItem("tutor"));
//     let tutor_ls = JSON.parse(localStorage.getItem("tutor")).saveTutor;

//     let temp_tutorSaveObj = {
//       ...tutor_ls,
//       tutStatus: "exl",
//     };
//     let temp_tutorObj = {
//       ...tutor1,
//       saveTutor: temp_tutorSaveObj,
//     };

//     props.setLocalSt(temp_tutorObj);

//     setTimeout(() => {
//       setLoaderVisible(false);
//       // alert("Something went wrong.Please try again!!")
//     }, 90000);

//     if (subList?.length !== 0) {
//       setLoaderVisible(true);
//       get_questions();
//     } else {
//       alert("Please select a subject!");
//     }
//   };

//   const re_attempt = useCallback(async () => {
//     const response = await axiosClient.post(
//       "/tutorweb/find_examId",
//       {
//         tutorId: JSON.parse(localStorage.getItem("tutor")).saveTutor.tutor_id,
//       }
//     );

//     if (response.status === 201 || response.status === 200) {
//       console.log(response.data.tutStatus, "<<<< tut status");
//     }
//   }, []);

//   useEffect(() => {
//     re_attempt();
//   }, []);

//   return (
//     <div>
//       {loaderVisible && <Loader1 />}
//       <div
//         role="main"
//         class="form-all form-desc-entrance"
//         // style={{ marginLeft: "27%", marginTop: "11rem", width: "50%" }}
//       >
//         <ul class="form-section page-section">
//           <h2
//             id="header_1"
//             class="form-header"
//             data-component="header"
//             style={{
//               textAlign: "center",
//               padding: "15px",
//               borderBottom: "1px solid grey",
//             }}
//           >
//             Tutor Registration Test
//           </h2>
//           {/* <div class="form-header-group  header-default">
//               <div class="header-text httac htvam">
//                 <h2
//                   id="header_1"
//                   class="form-header"
//                   data-component="header"
//                   style={{ textAlign: "center" }}
//                 >
//                   Tutor Registration Test
//                 </h2>
//               </div>
//             </div> */}

//           {/* <li>
//             <div
//               style={{
//                 height: "6rem",
//                 overflowY: "scroll",
//                 borderBottom: "ridge",
//                 marginBottom: "10px",
//                 marginLeft: "36px",
//                 marginRight: "36px",
//               }}
//             >
//               <p>
//                 <b>Attention Doers!</b>
//                 <br />
//                 Unlock Opportunities in High-Demand Subjects
//               </p>
//               <p style={{ fontSize: "13px" }}>
//                 Why should you consider becoming a Doer in high-demand subjects?
//                 <br /> ● Growing demand and increased amount of tasks.
//                 <br /> ● Competitive advantage: Doers who have cleared the test
//                 will be given priority <br /> ● Higher opportunity to earn{" "}
//               </p>
//               <p>High-Demand Subjects</p>
//               <p style={{ fontSize: "13px" }}>
//                 1. Artificial Intelligence
//                 <br />
//                 2. Project Management
//                 <br />
//                 3. Algorithms <br />
//                 4. Database Management System(DBMS)
//                 <br />
//                 5. Computer Networking
//                 <br />
//                 6. Marketing Management
//                 <br />
//                 7. Cloud Computing <br />
//                 8. Computer Architecture <br /> 9. Operating System <br />
//                 10. Machine Learning (ML) and Other Data Science topics
//               </p>
//             </div>
//           </li> */}
//           <li class="form-line" data-type="control_text" id="id_13">
//             <div id="cid_13" class="form-input-wide">
//               <div id="text_13" class="form-html" data-component="text">
//                 <strong>Rules and Regulations</strong>
//                 <ul className="rules-and-regulations">
//                   <li>
//                     The test consists of 25 multiple-choice questions and will
//                     last for 40 minutes.
//                   </li>
//                   <li>
//                     All answers must be submitted within the allotted time. The
//                     test will automatically submit when time expires.
//                   </li>
//                   <li>Participants are allowed only one submission.</li>
//                   <li>
//                     Grades will be available immediately after submitting the
//                     answers.
//                   </li>
//                   <li>
//                     <b>
//                       Any attempt to change tabs or navigate away from the test
//                       interface will result in automatic submission.
//                     </b>
//                   </li>
//                   <li>
//                     Integrity is paramount. Participants are expected to
//                     complete the test independently and honestly.
//                   </li>
//                   <li>
//                     If you have any questions or encounter technical issues,
//                     please contact us by mailing us at doer@urdoer.com Including
//                     a screenshot or screen recording will greatly assist us in
//                     resolving the problem efficiently.
//                   </li>
//                 </ul>
//                 {/* <small>
//                   The given time for this quiz is 45 minutes. After that, the
//                   form will be closed for you. Students who will not submit
//                   their answers in time will receive 0. You can only submit your
//                   answers once.
//                   once. If you wish to pause the the quiz, please use the Save and
//                 Continue Later button. Each question has its own grading points.
//                   After you submit your answers, we will evaluate your answers
//                   and let you know your grades later. If you have any technical
//                   problem during the quiz, please take a screenshot or screen
//                   recording and send us.
//                 </small> */}
//               </div>
//             </div>
//           </li>

//           <li class="form-line" data-type="control_fullname" id="id_3">
//             <label class="form-label form-label-top" id="label_3" for="first_3">
//               <strong>Select Your Subject </strong>
//             </label>
//             <Autocomplete
//               disablePortal
//               id="combo-box-demo"
//               options={props.subList}
//               getOptionLabel={(option) => {
//                 if (Array.isArray(option)) {
//                   return option[0];
//                 }
//                 return option;
//               }}
//               sx={{ width: 300 }}
//               onChange={changeHandler} // Use handleChange instead of changeHandler directly
//               renderInput={(params) => (
//                 <TextField {...params} label="Subject" />
//               )}
//             />
//             {/* <div id="cid_3" class="form-input-wide">
//               <div data-wrapper-react="true">
//                 <span
//                   class="form-sub-label-container"
//                   style={{ verticalAlign: "top" }}
//                   data-input-type="first"
//                 >
//                   <select
//                     type="text"
//                     id="first_3"
//                     name="q3_studentName[first]"
//                     class="form-textbox"
//                     data-defaultvalue=""
//                     autocomplete="section-input_3 given-name"
//                     size="10"
//                     value={testSubject}
//                     onChange={changeHandler}
//                     data-component="first"
//                     aria-labelledby="label_3 sublabel_3_first"
//                     style={{ height: "70px" }}
//                   >
//                     {props?.subList?.map((el) => (
//                       <option>{el}</option>
//                     ))}
//                   </select>
//                 </span>
//               </div>
//             </div> */}
//           </li>
//           <li class="form-line" data-type="control_button" id="id_2">
//             <div id="cid_2" class="form-input-wide">
//               <div
//                 style={{ textAlign: "center", dataAlign: "center" }}
//                 class="form-buttons-wrapper form-buttons-center   jsTest-button-wrapperField"
//               >
//                 {/* <Link to="/tutorExam"> */}
//                 <Button
//                   id="input_2"
//                   style={{ borderRadius: "5px", border: "none" }}
//                   //   type="submit"
//                   class="form-submit-button submit-button jf-form-buttons jsTest-submitField"
//                   onClick={handleClickOpen}
//                   data-component="button"
//                   data-content=""
//                 >
//                   Start Test
//                 </Button>
//                 {/* </Link> */}
//               </div>
//             </div>
//           </li>
//           <li>
//             <div
//               style={{
//                 textAlign: "-webkit-center",
//                 marginTop: "20px",
//                 marginBottom: "20px",
//               }}
//             >
//               <span style={{ fontSize: "15px" }}>
//                 If your subject is not present in this list,Please contact Us
//               </span>
//               <span style={{ marginLeft: "20px" }}>
//                 <Button
//                   variant="contained"
//                   className="ctaBtn"
//                   style={{
//                     background: "linear-gradient(127deg, #03D757, #11A1DC)",
//                     borderRadius: "35px",
//                     fontSize: "15px",
//                   }}
//                   endIcon={
//                     <WhatsAppIcon
//                       style={{ color: "#ffff", fontSize: "25px" }}
//                     />
//                   }
//                   href={"https://wa.me/916203738542"}
//                   target="_blank"
//                 >
//                   WhatsApp Now
//                 </Button>
//               </span>
//             </div>
//           </li>
//           <li style={{ display: "none" }}>
//             Should be Empty:
//             <input type="text" name="website" value="" />
//           </li>
//         </ul>
//       </div>
//       {showPauseAlertDialog && (
//         <PauseAlertDialog
//           showPauseAlertDialog={showPauseAlertDialog}
//           setShowPauseAlertDialog={setShowPauseAlertDialog}
//           submitHandler={nextHandler}
//         />
//       )}
//     </div>
//   );
// };

// export default TutorExamEntrance;

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { axiosClient } from "../../../../utils/auth.util";
import { useDispatch, useSelector } from "react-redux";
import { updateUserData } from "../../../../redux/slice/registerSlice";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  CircularProgress
} from "@mui/material";
import { School, Timer, CheckCircle } from "@mui/icons-material";

const TutorExamEntrance = (props) => {
  const [selectedSubject, setSelectedSubject] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get userData from Redux instead of localStorage
  const userData = useSelector(state => state.register.userData);
  const { tutorId, examId } = props;

  const handleSubjectSelect = (event) => {
    setSelectedSubject(event.target.value);
    setError("");
  };

  const startExam = useCallback(async () => {
    if (!selectedSubject) {
      setError("Please select a subject before starting the exam");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const subjectArray = [selectedSubject];
      
      const getQues = await axiosClient.post("/tutorweb/get_questions", {
        subjectList: subjectArray
      });

      if (getQues?.data?.questionArr?.length !== 0) {
        let keys = getQues.data.keyArr;
        let getQuesAr = getQues.data.questionArr;
        let base64String = [];

        getQuesAr.map((el) => {
          return base64String.push(
            btoa(
              new Uint8Array(el.data).reduce(function (data, byte) {
                return data + String.fromCharCode(byte);
              }, "")
            )
          );
        });

        // Update Redux state instead of localStorage
        dispatch(updateUserData({
          currentExam: {
            subject: selectedSubject,
            examId: examId,
            startTime: new Date().toISOString()
          }
        }));

        props.SelectedSub(subjectArray);
        props.CurrentBase64_func(base64String);
        props.key_func(keys);

        navigate("/register-dashboard/tutor_exam/test");
      } else {
        setError("No questions available for the selected subject");
      }
    } catch (error) {
      console.error("Error starting exam:", error);
      setError("Failed to start the exam. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, [selectedSubject, examId, tutorId, props, navigate, dispatch]);

  const getSubjectDisplayName = (subject) => {
    if (Array.isArray(subject)) {
      return subject[0];
    }
    return subject;
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h3" component="h1" gutterBottom color="primary">
          Academic Assessment
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Demonstrate your expertise in your chosen subject
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {/* Instructions Card */}
        <Grid item xs={12} md={6}>
          <Card elevation={3}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={2}>
                <School color="primary" sx={{ mr: 1 }} />
                <Typography variant="h5" component="h2">
                  Exam Instructions
                </Typography>
              </Box>
              
              <Typography variant="body1" paragraph>
                Welcome to your academic assessment. Please read the following instructions carefully:
              </Typography>
              
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  <Typography variant="body2" paragraph>
                    Select your preferred subject from the available options
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" paragraph>
                    You will have 40 minutes to complete the exam
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" paragraph>
                    The exam consists of multiple-choice questions
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" paragraph>
                    You need to score at least 70% to pass
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" paragraph>
                    Make sure you have a stable internet connection
                  </Typography>
                </li>
                <li>
                  <Typography variant="body2" paragraph>
                    Do not switch tabs or minimize the browser during the exam
                  </Typography>
                </li>
              </ul>
            </CardContent>
          </Card>
        </Grid>

        {/* Subject Selection Card */}
        <Grid item xs={12} md={6}>
          <Card elevation={3}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={2}>
                <Timer color="primary" sx={{ mr: 1 }} />
                <Typography variant="h5" component="h2">
                  Subject Selection
                </Typography>
              </Box>

              {props.subList && props.subList.length > 0 ? (
                <>
                  <FormControl fullWidth sx={{ mb: 3 }}>
                    <InputLabel>Choose Your Subject</InputLabel>
                    <Select
                      value={selectedSubject}
                      onChange={handleSubjectSelect}
                      label="Choose Your Subject"
                    >
                      {props.subList.map((subject, index) => (
                        <MenuItem key={index} value={getSubjectDisplayName(subject)}>
                          {getSubjectDisplayName(subject)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      {error}
                    </Alert>
                  )}

                  <Box textAlign="center">
                    <Button
                      variant="contained"
                      size="large"
                      onClick={startExam}
                      disabled={!selectedSubject || isLoading}
                      startIcon={isLoading ? <CircularProgress size={20} /> : <CheckCircle />}
                      sx={{
                        py: 1.5,
                        px: 4,
                        borderRadius: 2,
                        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                        '&:hover': {
                          background: 'linear-gradient(45deg, #1976D2 30%, #1BA0E3 90%)',
                        }
                      }}
                    >
                      {isLoading ? 'Starting Exam...' : 'Start Exam'}
                    </Button>
                  </Box>
                </>
              ) : (
                <Alert severity="info">
                  No subjects available for examination at this time.
                </Alert>
              )}

              {userData && (
                <Box mt={3} p={2} bgcolor="grey.100" borderRadius={1}>
                  <Typography variant="subtitle2" gutterBottom>
                    Exam Details:
                  </Typography>
                  <Typography variant="body2">
                    <strong>Candidate:</strong> {userData.fullName || userData.name}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Email:</strong> {userData.email}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Exam ID:</strong> {examId}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Additional Information */}
      <Box mt={4}>
        <Card elevation={1}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Important Notes:
            </Typography>
            <Typography variant="body2" color="text.secondary">
              • Once you start the exam, the timer will begin automatically
              <br />
              • You cannot pause or restart the exam once started
              <br />
              • Ensure you have completed your profile before taking the exam
              <br />
              • Results will be available immediately after submission
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default TutorExamEntrance;
